import { mtBannerWatermark } from "@assets/images";
import { PartnerLogoProps } from "@ctypes";
import { resolveLogoSize } from "@utils/logo";

const WIDTH = 100;
const HEIGHT = 98;

export const MntBannerWatermark = ({ className, style, width, height }: PartnerLogoProps) => {
  const size = resolveLogoSize({ width, height, naturalWidth: WIDTH, naturalHeight: HEIGHT });

  return (
    <img
      src={mtBannerWatermark}
      alt=""
      className={className}
      style={{ ...size, objectFit: "contain", ...style }}
    />
  );
};
